import SectionWrapper from "../../../components/layout/SectionWrapper";
import styled from "../../../util/styled";

const PREFIX = "AgendaMoreToKnow";

export const classes = {
  container: `${PREFIX}-container`,
  accordion: `${PREFIX}-accordion`,
  expandIcon: `${PREFIX}-expandIcon`,
};

export const StyledSectionWrapper = styled(SectionWrapper)(({ theme }) => ({
  [`& .${classes.container}`]: {
    display: "flex",
    flexDirection: "column",
  },

  [`& .${classes.accordion}`]: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: theme.palette.iaBlue.main,
    marginBottom: theme.spacing(2),
    backgroundColor: "transparent",
  },

  [`& .${classes.expandIcon}`]: {
    color: theme.palette.iaBlue.main,
  },
}));
